import React, { useEffect, useState } from "react";
import { AlertCircle, CalendarClock, Layers3, RefreshCw } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function OverviewPanel() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try { const r = await api.get("/admin/operations/overview"); setData(r.data); }
    catch { setData(null); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); const t = setInterval(load, 30000); return () => clearInterval(t); }, []);

  const cards = [
    { label: "Need attention", value: data?.attention?.total ?? "—", detail: `${data?.attention?.orders ?? 0} orders · ${data?.attention?.requests ?? 0} requests`, icon: AlertCircle },
    { label: "Next 24 hours", value: data?.next_24h?.total ?? "—", detail: "reservations and appointments", icon: CalendarClock },
    { label: "Active services", value: data?.modules?.active ?? "—", detail: `of ${data?.modules?.available ?? 0} platform modules`, icon: Layers3 },
  ];

  return (
    <div className="space-y-8" data-testid="operations-overview">
      <div className="flex items-start justify-between gap-4">
        <div>
          <div className="overline text-accent mb-2">Operations</div>
          <h1 className="font-display text-4xl md:text-5xl">What needs attention.</h1>
          <p className="text-muted-foreground mt-3 max-w-2xl">A compact operational picture. SLX-one keeps module complexity behind the scenes and surfaces only the work that matters now.</p>
        </div>
        <Button variant="outline" size="sm" onClick={load} disabled={loading}><RefreshCw className={`h-4 w-4 mr-2 ${loading ? "animate-spin" : ""}`} />Refresh</Button>
      </div>
      <div className="grid sm:grid-cols-3 gap-4">
        {cards.map(({ label, value, detail, icon: Icon }) => (
          <div key={label} className="border border-border bg-card p-6">
            <div className="flex items-center justify-between text-muted-foreground"><span className="overline text-[10px]">{label}</span><Icon className="h-4 w-4" /></div>
            <div className="font-display text-5xl mt-5">{value}</div>
            <div className="text-sm text-muted-foreground mt-2">{detail}</div>
          </div>
        ))}
      </div>
      <div className="border border-border bg-card p-6 md:p-8">
        <div className="font-display text-2xl">Crew-first by design</div>
        <p className="text-muted-foreground mt-2 max-w-3xl">As more services are enabled, this page stays simple. Orders, guest requests, reservations and escalations are aggregated here instead of forcing crew to check every module separately.</p>
      </div>
    </div>
  );
}
